class ShadeFinderQuizProductMatch extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.setupBackListeners()
    this.setupStartAgainListeners()

    // Listen for when this step is active
    this._observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const isActive = mutation.target.classList.contains('is-active')
          this.carouselManager(isActive)
        }
      }
    })

    this._observer.observe(this, { attributes: true })
  }

  disconnectedCallback () {
    super.disconnectedCallback()
    this._observer?.disconnect()
  }

  setupStartAgainListeners () {
    const startAgainBtns = document.querySelectorAll('[data-product-match-section-restart-trigger]')

    startAgainBtns.forEach(startAgainBtn => {
      this.listeners.add(startAgainBtn, 'click', () => {
        document.querySelector('shade-finder-quiz-product-match').classList.remove('is-active')
        document.querySelector('shade-finder-quiz-start').classList.add('is-active')

        const continueBtns = document.querySelectorAll('[data-modelfit-section-trigger]')
        continueBtns.forEach(continueBtn => {
          continueBtn.setAttribute('disabled', 'disabled')
        })
      })
    })
  }

  setupBackListeners () {
    const backBtns = document.querySelectorAll('[data-concealer-lightness-back-trigger]')
    const backBtnsModelfits = document.querySelectorAll('[data-modelfit-section-back-trigger]')

    backBtns.forEach(backBtn => {
      this.listeners.add(backBtn, 'click', () => {
        document.querySelector('shade-finder-quiz-product-match').classList.remove('is-active')
        document.querySelector('shade-finder-quiz-lighter-shade').classList.add('is-active')
        document.querySelector('shade-finder-quiz-modelfits').classList.remove('is-active')

        const addAllButton = document.querySelector('[data-shade-finder-results-add-all-button]')
        addAllButton?.setAttribute('aria-hidden', 'true')

        const lighterStep = document.querySelector('shade-finder-quiz-lighter-shade')
        const trueMatchInput = lighterStep?.querySelector('[data-shade-finder-quiz-lighter-shade-el="true-match-input"]')
        const lighterShadeInput = lighterStep?.querySelector('[data-shade-finder-quiz-lighter-shade-el="lighter-shade-input"]')

        if (trueMatchInput) trueMatchInput.checked = true
        if (lighterShadeInput) lighterShadeInput.checked = false
      })
    })

    backBtnsModelfits.forEach(backBtn => {
      this.listeners.add(backBtn, 'click', () => {
        document.querySelector('shade-finder-quiz-product-match').classList.remove('is-active')
        document.querySelector('shade-finder-quiz-modelfits').classList.remove('is-active')
        document.querySelector('shade-finder-quiz-skintone').classList.add('is-active')
      })
    })
  }

  carouselManager(pageActive) {
    if (pageActive === true) {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" })

      const trigger = document.querySelector('[data-product-match-section-trigger]')
      if (!trigger) return

      const matchProductVariantId = trigger.getAttribute('data-concealer-true-match-variant-id')
      if (!matchProductVariantId) return

      const matchedProducts = document.querySelectorAll(`[data-shade-finder-result]:not([aria-hidden='true'])`)

      if (!matchedProducts) return

      const productResultElements = document.querySelectorAll('.kla-Form-ProductResult')
      productResultElements.forEach(productResult => {
        let productTitles = []
        let productUrls = []
        let productVariants = []

        matchedProducts.forEach(matchedProduct => {
          productTitles.push(matchedProduct.getAttribute('data-product-handle'))
          productUrls.push(matchedProduct.getAttribute('data-variant-url'))
          productVariants.push(matchedProduct.getAttribute('data-variant-title'))
        })

        productResult.setAttribute('data-klaviyo-shade-finder-product-result', productTitles.toString())
        productResult.setAttribute('data-klaviyo-shade-finder-variant-result', productVariants.toString())
        productResult.setAttribute('data-klaviyo-shade-finder-product-url-result', productUrls.toString())
      })

      this.carousel = this.setupCarousel()
    } else {
      if (this.carousel) {
        this.carousel.destroy()
      }
    }
  }

  setupCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: `${this.els.slide.selector}:not([aria-hidden='true'])`,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView: 1.2,
          spacing: 2,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 3.7,
            },
          },
        },
      },
      [
        window.BAO.carousel.useInitialised(),
        window.BAO.carousel.useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('shade-finder-quiz-product-match')) {
  customElements.define('shade-finder-quiz-product-match', ShadeFinderQuizProductMatch)
}
